<!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
<template>
  <div
    class="promo-banner critical-component-hide"
    @focusin="state = 'paused'"
    @focusout="state = 'playing'"
    @mouseenter="state = 'paused'"
    @mouseleave="state = 'playing'"
    @touchstart.passive="state = 'paused'"
    @touchend="state = 'playing'"
  >
    <div class="promo-banner__inner container">
      <span
        class="visually-hidden"
        v-text="$string('general.site_header.promo_banner')"
      />
      <btn
        v-if="content.url && content.title"
        :url="content.url"
        modifiers="text dark"
        label-class="text-body-xs-regular"
        :label="content.title"
        class="promo-banner__content"
      />
      <div
        v-else-if="content.title"
        class="promo-banner__content text-body-xs-regular"
        v-html="formattedTitle"
      />
      <nav class="promo-banner__nav">
        <a
          class="promo-banner__nav-link text-body-xs-regular"
          :href="$string('general.site_header.our_locations_url')"
        >
          <icon-map-pin />
          <span
            v-text="$string('general.site_header.our_locations')"
          />
        </a>
        <a
          class="promo-banner__nav-link text-body-xs-regular"
          :href="$variable('routes.account.url')"
        >
          <icon-account />
          <span
            v-text="$string('general.site_header.account')"
          />
        </a>
      </nav>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Promo banner (promo-banner)
 * -----------------------------------------------------------------------------
 * Promo banner template.
 * - Conditionally loaded when section has blocks.
 * - Scroll-snap is used for basic scrolling and JS is used to scroll slides.
 * - For more advanced functionality add carousel.
 *
 * @param {Array} blocks - Promo blocks.
 * @param {Object} liquid - Liquid section ID, used for theme editor events.
 *
 */

import Btn from '~global/btn/btn.vue'
import IconAccount from '~icons/general/account.svg'
import IconMapPin from '~icons/general/map-pin.svg'

export default {
  name: 'PromoBanner',

  components: {
    Btn,
    IconAccount,
    IconMapPin,
  },
  props: {
    blocks: {
      type: Array,
      default: () => [],
    },
    // Needed for theme editor events
    // eslint-disable-next-line vue/no-unused-properties
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
      }),
    },
  },

  data() {
    return {
      currentSlide: 1,
      interval: {},
      state: 'playing',
    }
  },

  computed: {
    content() {
      return this.blocks[0]
    },

    /**
     * Returns formatted title.
     * @returns {String}
     */
    formattedTitle() {
      return this.content.title
        .replaceAll('<a', '<a class="text-body-xs-underline"')
        .replaceAll('<strong', '<strong class="text-body-xs-bold"')
    },
  },

  async mounted() {
    await this.$nextTick()
    cnvs.EventBus.emit('cnvs:update-site-header-height')
  },

  unmounted() {
    clearInterval(this.interval)
  },

  methods: {

    /**
     * Get block text.
     * - Applies text class to <a> elements.
     * @param {String} block - Block text.
     * @returns {String}
     */
    getBlockText(block) {
      return block
        .replaceAll('<a', '<a class="text-body-xs-regular"')
        .replaceAll('<strong', '<strong class="text-body-xs-regular"')
    },
  },
}
</script>

<style lang="scss">
@import './promo-banner';
</style>
